import React__default, { useContext } from 'react';
import Styles from './WhatsappOptIn.module.scss.js';
import { AppContext } from '../../app-context.js';
import AppCheckbox from '../app-checkbox/AppCheckbox.js';
import WhatsappIcon from '../../icons/WhatsappGreen.svg.js';

const WhatsappOptIn = ({ ischecked, onchange, containerStyles }) => {
    useContext(AppContext);
    return (React__default.createElement("div", { className: Styles.getWhatsappUpdate, style: containerStyles },
        React__default.createElement(AppCheckbox, { labelText: "Get updates on", isChecked: ischecked, onChange: onchange, 
            // styles={{ marginTop: getHeightByViewPort(30) }}
            styles: {
                fontWeight: "bolder",
                width: "125px",
                fontSize: "11px",
                color: "#0D132D"
            } }),
        React__default.createElement("span", { className: Styles.whatsApp },
            React__default.createElement(WhatsappIcon, null),
            "WhatsApp")));
};

export { WhatsappOptIn as default };
//# sourceMappingURL=WhatsappOptIn.js.map
